import Loadable from 'react-loadable';

const AsyncWork = Loadable({
  loader: () => import(/* webpackChunkName: "work" */ './AsyncWorkRoute.js'),
  loading: () => null
});

export default AsyncWork;
